/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Update cart count badge
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
      })
      .catch(error => console.error('Error fetching cart:', error));
  }
  function calculationMobbileSearchBarHeight() {
    const el = document.querySelector('.mobile-search-bar');
    if (!el) return;

    const height = el.offsetHeight;
    document.documentElement.style.setProperty('--mobile-search-bar-height', `${height}px`);
  }
  // Update cart count on page load
  document.addEventListener('DOMContentLoaded', updateCartCount);

  function isPlainObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function hasStyleProfileProperties(data) {
    if (!isPlainObject(data) || !isPlainObject(data.properties)) return false;
    return Object.keys(data.properties).length > 0;
  }

  const STYLE_PROFILE_CACHE_KEY = 'birdsnestStyleProfileStatus';

  function readStyleProfileCache() {
    try {
      const rawCache = localStorage.getItem(STYLE_PROFILE_CACHE_KEY);
      if (!rawCache) return null;

      const cache = JSON.parse(rawCache);
      if (!isPlainObject(cache) || typeof cache.hasProfile !== 'boolean') return null;

      return cache;
    } catch (error) {
      console.warn('[birdsnest style profile debug] Failed to read cache:', error);
      return null;
    }
  }

  function writeStyleProfileCache(data, endpoint) {
    try {
      const hasProfile = hasStyleProfileProperties(data);
      const cache = {
        endpoint,
        hasProfile,
        data,
        updatedAt: new Date().toISOString()
      };

      localStorage.setItem(STYLE_PROFILE_CACHE_KEY, JSON.stringify(cache));
      return cache;
    } catch (error) {
      console.warn('[birdsnest style profile debug] Failed to write cache:', error);
      return null;
    }
  }

  function createStyleProfileStatusData(hasProfile) {
    return {
      properties: hasProfile ? { cachedProfileStatus: true } : {}
    };
  }

  function isStyleProfileEndpoint(url) {
    return typeof url === 'string' && url.includes('/v1/customers/style-profiles');
  }

  function getFetchUrl(input) {
    return typeof input === 'string' ? input : input && input.url;
  }

  function getFetchMethod(input, init) {
    const method = init && init.method ? init.method : input && input.method;
    return (method || 'GET').toUpperCase();
  }

  function getStyleProfilePayloadFromBody(body) {
    if (typeof body !== 'string') return null;

    try {
      const parsedBody = JSON.parse(body);
      if (isPlainObject(parsedBody) && isPlainObject(parsedBody.klaviyo_payload)) {
        return { properties: parsedBody.klaviyo_payload };
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function installStyleProfileCacheInterceptor() {
    if (window.birdsnestStyleProfileCacheInterceptorInstalled || typeof window.fetch !== 'function') return;

    const originalFetch = window.fetch.bind(window);
    window.birdsnestStyleProfileCacheInterceptorInstalled = true;

    window.fetch = function(input, init) {
      const url = getFetchUrl(input);
      const method = getFetchMethod(input, init);
      const requestPayload = method === 'POST' && init ? getStyleProfilePayloadFromBody(init.body) : null;

      return originalFetch(input, init).then(response => {
        if (!isStyleProfileEndpoint(url) || !response.ok) return response;

        response.clone().json()
          .then(data => {
            const cacheData = hasStyleProfileProperties(data) ? data : requestPayload;
            if (!cacheData) return;

            const cache = writeStyleProfileCache(cacheData, url);
            if (cache) {
              updateHeaderInfoBarStyleProfile(createStyleProfileStatusData(cache.hasProfile));
            }
          })
          .catch(() => {
            if (!requestPayload) return;

            const cache = writeStyleProfileCache(requestPayload, url);
            if (cache) {
              updateHeaderInfoBarStyleProfile(createStyleProfileStatusData(cache.hasProfile));
            }
          });

        return response;
      });
    };
  }

  function updateHeaderInfoBarStyleProfile(data) {
    const header = document.querySelector('[data-style-profile-header]');
    const trigger = header ? header.querySelector('.header-info-bar__tooltip-trigger') : null;
    if (!trigger) return null;

    const currentText = trigger.textContent.replace(/\s+/g, ' ').trim();
    if (!currentText.startsWith('Hi ')) return null;

    const nameMatch = currentText.match(/^Hi\s+(.+?)!/);
    const customerName = nameMatch && nameMatch[1] ? nameMatch[1].trim() : 'Gorgeous';
    const hasProfile = hasStyleProfileProperties(data);
    const setupUrl = header.dataset.styleProfileSetupUrl || '/pages/meet-your-match';
    const matchesUrl = header.dataset.styleProfileMatchesUrl || '/pages/style-matches';
    const actionText = hasProfile ? 'View your style matches' : 'Set up your style profile';
    const actionUrl = hasProfile ? matchesUrl : setupUrl;

    let link = trigger.querySelector('[data-style-profile-header-link]');
    if (!link) {
      trigger.textContent = `Hi ${customerName}! `;
      link = document.createElement('a');
      link.className = 'header-info-bar__link';
      link.style.color = 'inherit';
      link.setAttribute('data-style-profile-header-link', '');
      trigger.appendChild(link);
    }

    link.textContent = actionText;
    link.href = actionUrl;

    return hasProfile;
  }

  function fetchStyleProfileDebug() {
    const endpoint = '/apps/api-proxy/v1/customers/style-profiles';
    const cachedStatus = readStyleProfileCache();

    if (cachedStatus) {
      updateHeaderInfoBarStyleProfile(createStyleProfileStatusData(cachedStatus.hasProfile));

      window.birdsnestStyleProfileDebug = {
        endpoint,
        ok: true,
        status: 'cached',
        data: cachedStatus.data || createStyleProfileStatusData(cachedStatus.hasProfile),
        hasProfile: cachedStatus.hasProfile,
        requestedAt: cachedStatus.updatedAt,
        completedAt: cachedStatus.updatedAt,
        cacheKey: STYLE_PROFILE_CACHE_KEY
      };

      console.log('[birdsnest style profile debug]', window.birdsnestStyleProfileDebug);
      return Promise.resolve(window.birdsnestStyleProfileDebug.data);
    }

    window.birdsnestStyleProfileDebug = {
      endpoint,
      status: 'loading',
      requestedAt: new Date().toISOString()
    };

    return fetch(endpoint, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(async response => {
        const contentType = response.headers.get('content-type') || '';
        const body = contentType.includes('application/json')
          ? await response.json()
          : await response.text();
        const hasProfile = response.ok ? updateHeaderInfoBarStyleProfile(body) : null;
        const cache = response.ok ? writeStyleProfileCache(body, endpoint) : null;

        window.birdsnestStyleProfileDebug = {
          endpoint,
          ok: response.ok,
          status: response.status,
          statusText: response.statusText,
          data: body,
          hasProfile,
          cacheKey: STYLE_PROFILE_CACHE_KEY,
          cacheUpdatedAt: cache ? cache.updatedAt : null,
          requestedAt: window.birdsnestStyleProfileDebug.requestedAt,
          completedAt: new Date().toISOString()
        };

        console.log('[birdsnest style profile debug]', window.birdsnestStyleProfileDebug);

        if (!response.ok) {
          throw new Error(`Style profile API failed with status ${response.status}`);
        }

        return body;
      })
      .catch(error => {
        window.birdsnestStyleProfileDebug = {
          endpoint,
          ok: false,
          status: 'error',
          error: error.message,
          requestedAt: window.birdsnestStyleProfileDebug.requestedAt,
          completedAt: new Date().toISOString()
        };

        console.error('[birdsnest style profile debug]', error);
        return null;
      });
  }

  window.birdsnestFetchStyleProfileDebug = fetchStyleProfileDebug;
  installStyleProfileCacheInterceptor();

  document.addEventListener('DOMContentLoaded', fetchStyleProfileDebug);
  document.addEventListener('click', function (e) {
    const closeButton = e.target.closest('[data-cart-continue-shopping-close]');
    if (!closeButton) return;

    e.preventDefault();

    const cartDrawer = closeButton.closest('[data-cart-drawer]');
    const drawerCloseButton = cartDrawer ? cartDrawer.querySelector('.cart-drawer__close[data-cart-drawer-toggle]') : null;

    if (drawerCloseButton && drawerCloseButton !== closeButton) {
      drawerCloseButton.click();
      return;
    }

    document.body.classList.remove('js-drawer-open-cart');
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    document.dispatchEvent(new CustomEvent('theme:cart:close', { bubbles: true }));
  });

  // Update cart count when cart is loaded/changed
  document.addEventListener('theme:cart:loaded', updateCartCount);

  // Update cart count when items are added to cart
  document.addEventListener('theme:cart:added', updateCartCount);

  // Update cart count when cart is updated (items removed, quantities changed)
  document.addEventListener('theme:cart:update', updateCartCount);

  document.addEventListener('DOMContentLoaded', calculationMobbileSearchBarHeight);

  // Unhide size guide / will-this-suit-me buttons if JS is working
  document.documentElement.classList.add('js-drawer-actions-ready');

  // Handle clicks on radio legend actions to open drawers
  document.addEventListener('click', function (e) {
    const action = e.target.closest('.radio__legend__action');
    if (!action) return;

    e.preventDefault();

    let drawer = null;
    let sectionId = null;

    const productForm = action.closest('product-form');
    if (productForm && productForm.dataset.unique) {
      sectionId = productForm.dataset.unique; // This is actually section_id
      drawer = document.getElementById(`size-guide--${sectionId}`);
    }

    if (!drawer) {
      const productInfo = action.closest('product-info');
      if (productInfo && productInfo.dataset.section) {
        sectionId = productInfo.dataset.section;
        drawer = document.getElementById(`size-guide--${sectionId}`);
      }
    }

    if (!drawer && action.dataset.sectionId) {
      sectionId = action.dataset.sectionId;
      drawer = document.getElementById(`size-guide--${sectionId}`);
    }

    if (!drawer) return;

    const type = action.dataset.openDrawer;
    const targetTabIndex = type === 'size' ? 0 : 1;

    drawer.dispatchEvent(
      new CustomEvent('theme:drawer:toggle', {
        detail: { trigger: action }
      })
    );

    setTimeout(() => {
      const tabsComponent = drawer.querySelector('tabs-component');
      if (!tabsComponent) return;

      const tabLink = tabsComponent.querySelector(
        `[data-tabs-link="${targetTabIndex}"]`
      );

      if (tabLink) tabLink.click();
    }, 50);
});

  // Force the "Sizing and Fit" PDP accordion to always open the Size Guide tab.
  // This trigger opens the shared size-guide drawer via its own <drawer-toggle>
  // element (so we must not dispatch theme:drawer:toggle again here — that would
  // immediately re-close the drawer). We only need to reset the active tab, since
  // the drawer keeps whatever tab was last left active in the DOM.
  document.addEventListener('click', function (e) {
    const action = e.target.closest('.accordion--size-guide');
    if (!action) return;

    const targetId = action.getAttribute('aria-controls');
    if (!targetId) return;

    const drawer = document.getElementById(targetId);
    if (!drawer) return;

    setTimeout(() => {
      const tabsComponent = drawer.querySelector('tabs-component');
      if (!tabsComponent) return;

      const tabLink = tabsComponent.querySelector('[data-tabs-link="0"]');
      if (tabLink) tabLink.click();
    }, 50);
  });

  // Override reviews.io rating widget click — scroll to reviews section instead of opening modal
  // Only applies on product pages (PDP); other pages retain the default popup behaviour
  document.addEventListener('click', function (e) {
    if (!document.body.classList.contains('template-product')) return;
    if (!e.target.closest('reviewsio-product-ratings')) return;

    e.stopImmediatePropagation();
    e.preventDefault();

    const reviewsSection = document.querySelector('#ReviewsWidget');
    if (!reviewsSection) return;

    const stickyHeader = document.querySelector('.header-sticky-wrapper, [data-sticky-header]');
    const offset = (stickyHeader ? stickyHeader.offsetHeight : 0) + 120;
    const top = reviewsSection.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top: top, behavior: 'smooth' });
  }, true); // capture: true — intercepts before reviews.io's own handlers

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
(function () {
  var trigger = document.querySelector('[data-profile-popover-trigger]');
  var pop = document.querySelector('[data-profile-popover]');
  var closeBtn = pop ? pop.querySelector('[data-nav-profile-close]') : null;
  if (!trigger || !pop) return;
  function open() {
    pop.classList.add('is-open');
    pop.setAttribute('aria-hidden','false');
    trigger.setAttribute('aria-expanded','true');
  }
  function close() {
    pop.classList.remove('is-open');
    pop.setAttribute('aria-hidden','true');
    trigger.setAttribute('aria-expanded','false');
  }
  function toggle() { pop.classList.contains('is-open') ? close() : open(); }

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    toggle();
  });

  document.addEventListener('click', function (e) {
    if (!pop.contains(e.target) && e.target !== trigger) close();
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') close();
  });
})();
